<template>
  <div class="flex justify-between mb-12 text-white mt-60 mx-36 font-neue">
    <a href="https://www.linkedin.com/in/cyril-semabia"
      >www.linkedin.com/in/cyril-semabia</a
    >

    <a href="https://github.com/justmecyril">https://github.com/justmecyril</a>

    <p>Designed by me</p>
    <p>© 2021. All rights reserved</p>
  </div>
</template>

<script>
export default {
  name: "FooterView",
};
</script>
